import { useState, useMemo } from 'react';
import { useFuse } from '../components/useFuse';
import CloseIcon from '@mui/icons-material/Close';

export default function ProductAutocomplete({ products, productId, productLabel, onChange, placeholder }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [inputActive, setInputActive] = useState(false);
  const [mouseOverResult, setMouseOverResult] = useState(false);

  const list = useMemo(
    () => (products || []).map((product) => ({
      id: product.id,
      label: product.model,
      desc: product.description,
    })),
    [products]
  );

  const searchResults = useFuse(searchTerm, list);

  const handleSelect = (option) => {
    onChange({ id: option.id, model: option.label });
    setSearchTerm('');
    setInputActive(false);
  };

  const handleClear = () => {
    onChange(null);
    setSearchTerm('');
    setInputActive(true);
  };

  const exactMatch = (query, text) => {
    const regex = new RegExp(`^${query}`, 'i');
    return regex.test(text);
  };

  if (productId) {
    return (
      <div className="ww-product-autocomplete">
        <span className="ww-account-chip">
          {productLabel || 'Selected product'}
          <button type="button" onClick={handleClear} aria-label="Clear product">
            <CloseIcon />
          </button>
        </span>
      </div>
    );
  }

  return (
    <div className="ww-product-autocomplete">
      <div className={`ww-account-search ${inputActive ? 'active' : ''}`}>
        <input
          className="ww-price-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder || 'Search products'}
          onFocus={() => setInputActive(true)}
          onBlur={() => (mouseOverResult ? null : setInputActive(false))}
        />
        <div className={`ww-account-results ${inputActive && searchTerm ? 'shown' : ''}`}>
          {searchResults.slice(0, 10).map((result) => (
            <button
              key={result.id}
              type="button"
              className={`ww-account-result ${exactMatch(searchTerm, result.label) ? 'exact-match' : ''}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(result)}
              onMouseOver={() => setMouseOverResult(true)}
              onMouseLeave={() => setMouseOverResult(false)}
            >
              <span>{result.label}</span>
              {result.desc ? <span className="ww-product-result-desc"> — {result.desc}</span> : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
